import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '@/lib/use-auth';

export function LogoutPage() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await logout();
      } catch {
        // Best-effort logout; backend may have already revoked the cookie.
      }
      if (!cancelled) navigate('/login', { replace: true });
    })();
    return () => {
      cancelled = true;
    };
  }, [logout, navigate]);

  return (
    <div className="grid min-h-[40vh] place-items-center text-sm text-slate-500">
      Signing out…
    </div>
  );
}
